import { render, staticRenderFns } from "./ibToggle.vue?vue&type=template&id=449637cb&scoped=true"
import script from "./ibToggle.vue?vue&type=script&lang=js"
export * from "./ibToggle.vue?vue&type=script&lang=js"
import style0 from "./ibToggle.vue?vue&type=style&index=0&id=449637cb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "449637cb",
  null
  
)

export default component.exports